import {
  ConfigProvider,
  Dropdown,
  Input,
  Modal,
  Pagination,
  Select,
  Table,
  Typography,
} from "antd";
import CommonAdminTable from "../../components/commonTable";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  ApproveWarranty,
  GetPpfDetailsWhileApprove,
  GetWarrantyList,
} from "../../../redux/actions/warranty/warranties-action";
import Alertify from "../../../services/alertify";
import { MoreOutlined } from "@ant-design/icons";
import { LoaderIcon } from "react-hot-toast";
import { useLocation } from "wouter";
const { Text, Title } = Typography;
const WarrantyList = () => {
  const [approveModal, setApproveModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [vehicleId, setVehicleId] = useState(null);
  const [ppfRollNumber, setPpfRollNumber] = useState([]);
  const [ppfRollNumberCancel, setPpfRollNumberCancel] = useState();
  const [totalSqft, setTotalSqft] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [, setLocation] = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [approveDataSource, setApproveDataSource] = useState([]);
  const [mainClaim, setMainClaim] = useState(null);
  const [partialClaim, setPartialClaim] = useState(null);
  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },

    {
      title: "Vehicle id",
      dataIndex: "vehicleId",
      key: "vehicleId",
      hidden: true,
    },
    {
      title: "PPF Roll Number",
      dataIndex: "ppfRollNumber",
      key: "ppfRollNumber",
    },
    { title: "QR Id", dataIndex: "qrId", key: "qrId", hidden: true },
    {
      title: "Variant",
      dataIndex: "variantUsed",
      key: "variantUsed",
      align: "center",
    },
    {
      title: "Vehicle No",
      dataIndex: "vehicleRegistrationNumber",
      key: "vehicleRegistrationNumber",
    },
    { title: "Vehicle Brand", dataIndex: "vehicleBrand", key: "carMake" },
    { title: "Vehicle Model", dataIndex: "vehicleModel", key: "carModel" },
    { title: "Customer Name", dataIndex: "customerName", key: "customerName" },
    {
      title: "Customer Email",
      dataIndex: "customerEmail",
      key: "customerEmail",
    },

    {
      title: "Applicator's Name",
      dataIndex: "detailerName",
      key: "detailerName",
    },
    {
      title: "Applicator's Phone No",
      dataIndex: "detailerPhoneNo",
      key: "detailerPhoneNo",
    },
    {
      title: "Application Date",
      dataIndex: "applicationDate",
      key: "applicationDate",
    },
    {
      title: "Total SQFT Used",
      dataIndex: "totalSqftUsed",
      key: "totalSqftUsed",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          className={`py-1 px-2 rounded-md ${
            status === "Approved"
              ? "text-[#049E0B] bg-[#A6D8A8]"
              : status === "Cancelled"
              ? "text-red-600 bg-red-300"
              : "text-[#8143D1] bg-[#3E79F71A]"
          }`}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const items = [
          {
            key: "approve",
            label: "Review Request",
            disabled: record.status === "Approved",
            onClick: () => {
              setApproveModal(true);
              setVehicleId(record.vehicleId);
              setMainClaim(record.totalSqftUsed);
              setPartialClaim(record.partialSqftUsed);
              setPpfRollNumber([
                record.ppfRollNumber,
                record.ppfRollNumberPartial,
              ]);
              setTotalSqft(record.totalSqftUsed);
            },
          },
          {
            key: "cancel",
            label: "Cancel",
            disabled: record.status === "Cancelled",
            onClick: () => {
              setCancelModal(true);
              setVehicleId(record.vehicleId);
              setPpfRollNumberCancel(record.ppfRollNumber);
              setTotalSqft(record.totalSqftUsed);
            },
          },
          {
            key: "view",
            label: "View Details",
            onClick: () =>
              setLocation(`/admin/warranty-details/${record.vehicleId}`),
          },
        ];

        return (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <MoreOutlined
              style={{ fontSize: "20px", cursor: "pointer" }}
              className="p-1 rounded-full hover:bg-gray-100"
            />
          </Dropdown>
        );
      },
    },
  ];
  const [warrantyStatus, setWarrantyStatus] = useState("");
  const [dataSource, setDataSource] = useState([]);
  console.log("ppfRollNumber", ppfRollNumber);
  const dispatch = useDispatch();
  useEffect(() => {
    if (ppfRollNumber.length === 0) return;
    dispatch(GetPpfDetailsWhileApprove({ ppfRollNumbers: ppfRollNumber })).then(
      (response) => {
        setApproveDataSource(response?.payload?.data?.totalSqftUsed);
      }
    );
  }, [ppfRollNumber]);
  const cancelWarranty = () => {
    setLoading(true);
    dispatch(ApproveWarranty({ warrantyId: vehicleId, status: "Cancelled" }))
      .then((response) => {
        // console.log(response);
        // Check if the response contains an error
        if (
          response.error ||
          (response.payload && response.payload.statusCode >= 400)
        ) {
          const errorMessage =
            response.payload?.message || "Error approving warranty";
          Alertify.error(errorMessage);
        } else {
          Alertify.success("Warranty rejected successfully");
          setCancelModal(false);
          fetchWarrantyList();
        }
        setLoading(false);
      })
      .catch((error) => {
        const errorMessage =
          error?.message || "Error approving warranty. Please try again.";
        Alertify.error(errorMessage);
        setLoading(false);
      });
  };

  const fetchWarrantyList = () => {
    dispatch(
      GetWarrantyList({
        status: warrantyStatus,
        page: currentPage,
        limit: pageSize,
        search: searchText,
      })
    )
      .then((response) => {
        const data = response?.payload?.data?.data || [];
        const dataWithKeys = data.map((item, index) => ({
          ...item,
          key: item.vehicleId || `warranty-${index}`,
        }));
        setDataSource(dataWithKeys);
        setTotalPages(response?.payload?.data?.total);
      })
      .catch((error) => {
        Alertify.error("Error fetching warranty list. Please try again.");
      });
  };

  useEffect(() => {
    fetchWarrantyList();
  }, [dispatch, warrantyStatus, currentPage, searchText]);
  //   console.log("warrantyStatus", warrantyStatus);
  const approveWarranty = () => {
    setLoading(true);
    dispatch(ApproveWarranty({ warrantyId: vehicleId, status: "Approved" }))
      .then((response) => {
        // console.log(response);
        // Check if the response contains an error
        if (
          response.error ||
          (response.payload && response.payload.statusCode >= 400)
        ) {
          const errorMessage =
            response.payload?.message || "Error approving warranty";
          Alertify.error(errorMessage);
        } else {
          Alertify.success("Warranty approved successfully");
          setApproveModal(false);
          fetchWarrantyList();
        }
        setLoading(false);
      })
      .catch((error) => {
        const errorMessage =
          error?.message || "Error approving warranty. Please try again.";
        Alertify.error(errorMessage);
        setLoading(false);
      });
  };
  // console.log("total pages state", totalPages);
  const approveColumns = [
    {
      title: "",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Roll Number",
      dataIndex: "rollNumber",
      key: "ppfRollNumber",
    },
    {
      title: "Total SQFT",
      dataIndex: "totalSqft",
      key: "totalSqft",
    },
    {
      title: "Used till date",
      dataIndex: "totalUsedSqft",
      key: "totalSqftUsed",
    },
    {
      title: "Claim",
      dataIndex: "claim",
      key: "claim",
    },
  ];
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
          },
          Modal: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <div className="flex justify-between p-4 itmes-center">
        <Title level={2} className="text-start">
          Warranty Registration
        </Title>
        <Input.Search
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search PPF Roll Number"
          style={{ width: 200, marginBottom: 0, height: 35 }}
        />
        <Select
          className="w-[150px] rounded-md"
          value={warrantyStatus}
          placeholder="Select Status"
          onChange={(value) => setWarrantyStatus(value)}
          options={[
            { value: "", label: "Select Status" },
            { value: "Approved", label: "Approved" },
            { value: "Pending", label: "Pending" },
            { value: "Cancelled", label: "Cancelled" },
          ]}
        />
      </div>
      <CommonAdminTable columns={columns} data={dataSource} />
      <Pagination
        className="mt-4"
        align="center"
        current={currentPage}
        pageSize={pageSize}
        total={totalPages}
        onChange={(page, pageSize) => {
          setCurrentPage(page);
          setPageSize(pageSize);
        }}
        // hideOnSinglePage
      />
      {approveModal && (
        <Modal
          open={approveModal}
          className="rounded-lg"
          centered
          width={1000}
          onCancel={() => {
            setApproveModal(false);
            setPpfRollNumber([]);
            setApproveDataSource([]);
            setMainClaim(null);
            setPartialClaim(null);
          }}
          footer={false}
        >
          <Title level={3} className="m-0">
            You are about to approve this request.
          </Title>
          <Title level={3} className="m-0">
            Do you want to proceed?
          </Title>

          <Table
            columns={approveColumns}
            dataSource={[...approveDataSource].reverse().map((item, index) => ({
              ...item,
              key: `approve-row-${index}`,
              index:
                index === 1 ? (
                  <div className="font-bold">Partial PPF</div>
                ) : (
                  <div className="font-bold">Main PPF</div>
                ),
              claim: index === 1 ? partialClaim : mainClaim,
            }))}
            pagination={false}
            scroll={{ x: 800 }}
          />
          <div className="flex justify-end mt-4">
            <button
              className="mr-2 px-4 py-2 bg-blue-500 text-white rounded-md w-[100px]"
              onClick={approveWarranty}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <LoaderIcon />
                </div>
              ) : (
                "Approve"
              )}
            </button>
            <button
              className="px-4 py-2 text-gray-700 bg-gray-300 rounded-md"
              onClick={() => setApproveModal(false)}
            >
              Cancel
            </button>
          </div>
        </Modal>
      )}

      {cancelModal && (
        <Modal
          open={cancelModal}
          className="rounded-lg"
          centered
          onCancel={() => setCancelModal(false)}
          footer={false}
        >
          <Title level={3} className="m-0">
            You are about to reject this request.
          </Title>
          <Title level={3} className="m-0">
            Do you want to proceed?
          </Title>
          {/* <div className="flex items-center mt-4">
            <Title level={5} className="w-1/3">
              PPF Roll Number:{" "}
            </Title>
            <Text>{ppfRollNumberCancel}</Text>
          </div>
          <div className="flex items-center mt-4">
            <Title level={5} className="w-1/3">
              Total SQFT Used:{" "}
            </Title>
            <Text>{totalSqft}</Text>
          </div> */}
          <div className="flex justify-start mt-4">
            <button
              className="mr-2 px-4 py-2 bg-blue-500 text-white rounded-md w-[150px]"
              onClick={cancelWarranty}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <LoaderIcon />
                </div>
              ) : (
                "Cancel Request"
              )}
            </button>
            <button
              className="px-4 py-2 text-gray-700 bg-gray-300 rounded-md"
              onClick={() => setCancelModal(false)}
            >
              Cancel
            </button>
          </div>
        </Modal>
      )}
    </ConfigProvider>
  );
};

export default WarrantyList;
